import debounce from 'lodash/debounce';
import axios from 'axios';
import APP_CONSTANTS from '@ordermentum/ui-constants';

type Callback = {
  (type: string): any;
};

/**
 * @description This is a debouncer factory function which takes a callback and calls that callback after fetching
 * a card type for the card number passed to the function this factory returns.
 * @example 2345 XXXX => will give back mastercard and the callback is called with "mastercard" as the return type
 *
 * @param {Callback} callback Callback called after fetching credit card type
 * @returns {(((cardNumber: String) => Promise<string>) & Cancelable)}
 */
// TODO(ish): Integrate SWR. Move this function.
export const createCreditCardTypeDebouncer = (callback: Callback) =>
  debounce(
    async (cardNumber: String) => {
      try {
        const response = await axios.post(
          '/v1/payment-methods/card-type/',
          { cardNumber },
          {
            responseType: 'json',
            timeout: 20000,
          }
        );
        return callback(response.data ? response.data.toLowerCase() : '');
      } catch (err) {
        return callback('');
      }
    },
    500,
    { maxWait: 600 }
  );

export const getCCExpiryYear = expiryDate => {
  if (expiryDate.length > APP_CONSTANTS.EXPIRY_YEAR_POSITION) {
    return `20${expiryDate.substr(
      APP_CONSTANTS.EXPIRY_YEAR_POSITION,
      expiryDate.length
    )}`;
  }
  return '20';
};
